import React from 'react';
import { useSelector } from 'react-redux';

import type { WCardSuiteSummaryView } from '@zola/svc-web-api-ts-client';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import { TagV2, TagV2Variant } from '@zola/zola-ui/src/components/Tag/TagV2';
import { getCardSuitePath } from '@zola/zola-ui/src/paper/cards/util/getCardUrl';
import { getCollaborators } from 'cards/selectors/cardCatalogSelector';
import { MagicTag } from 'cards/components/common/Tags/MagicTag';
import { LeadCardType } from '@zola/zola-ui/src/paper/cards/constants/cardTypes';
import {
  SuiteNameContainer,
  CardName,
  StyledFoilTag,
  StyledLetterpressTag,
} from './SuiteName.style';

interface SuiteNameProps {
  suite: WCardSuiteSummaryView;
  hideTags?: boolean;
}

export const SuiteName: React.FC<SuiteNameProps> = ({ suite, hideTags }) => {
  const collaborators = useSelector(getCollaborators);
  const { lead_card: card, uuid: suiteUUID } = suite;

  if (!card) return null;

  const [, cardName] = card.name?.split(' - ') || [];
  const collaborator = collaborators[suite.collaborator || ''];

  const pathname = getCardSuitePath(card.type as LeadCardType, suiteUUID as string);
  return (
    <SuiteNameContainer>
      <LinkV2 href={pathname} aria-label={card.name} noUnderline>
        <CardName>{cardName}</CardName>
      </LinkV2>
      {!hideTags ? (
        <>
          {card.foil && <StyledFoilTag />}
          {card.letterpress && <StyledLetterpressTag />}
          {suite.collaborator?.toLowerCase() === 'disney' && <MagicTag />}
          {collaborator && <TagV2 variant={TagV2Variant.PURPLE}>Zola x {collaborator.label}</TagV2>}
        </>
      ) : null}
    </SuiteNameContainer>
  );
};
